// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2V5m0","title":"Images45_title__RUVJZ","images":"Images45_images__wg-_j"};